export default __webpack_public_path__ + "static/media/PAFI_LKTT 2023.2693bafa.pdf";